import React, { ChangeEvent, Component, useState } from "react";
import "./QboPushCustomersModal.scss";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import ISupplierModel from "../../../../models/ISupplierModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";

type Props = {
    closeModalFn: () => void;
    startFn: (options: { onlyUnconnected: boolean }) => void;
};

export const QboPushCustomersModal: React.FC<Props> = (props) => {
    const [onlyUnconnected, setOnlyUnconnected] = useState(false);

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        switch (name) {
            case "only_push_unconnected_accounts":
                setOnlyUnconnected(!onlyUnconnected);
                break;
        }
    };

    const start = () => {
        props.startFn({ onlyUnconnected });
    };

    return (
        <div className={"QboPushCustomersModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fas fa-exchange"} title={"push_customers"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"}>
                <OwCheckbox
                    label={"only_push_unconnected_accounts"}
                    fn={handleChange}
                    name={"only_push_unconnected_accounts"}
                    truthyVal={true}
                    falsyVal={false}
                    checked={onlyUnconnected}
                />
            </div>

            <div className="mt-3">
                <OwButton title={"start"} fn={start} />
            </div>
        </div>
    );
};
